import script from "./AddNewManager.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddNewManager.vue?vue&type=script&lang=ts&setup=true"

export default script